module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending-conciliation-box",
    attrs: {
      "id": "selected-entries-wrapper"
    }
  }, [_c('reopen-allotment-modal'), _c('apply-modal'), _c('justify-modal'), _c('h4', {
    staticClass: "pending-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.portletSelecionados'))
    }
  }), (_vm.allotmentId != null && _vm.allotmentMovementRemoved == null) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "pending-title",
    staticStyle: {
      "color": "#00ace6 !important",
      "font-size": "18px",
      "padding-right": "15px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.loteSelecionado'))
    }
  }), _c('span', {
    staticClass: "span-tag"
  }, [_vm._v(_vm._s(_vm.allotmentId)), _c('button', {
    staticClass: "close-tag-btn close-tag-span fa fa-times action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeAllotment
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 row-flex"
  }, [_c('div', {
    staticClass: "col-xs-6 grey-right-border col-flex"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "pending-title-manual-conciliation bold pull-left",
    staticStyle: {
      "color": "#00ace6 !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.gridMovimentosFinanceiros'))
    }
  }), (_vm.internalEntries.length > 0) ? _c('a', {
    staticClass: "pull-right clear-link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.limpar'))
    },
    on: {
      "click": function($event) {
        return _vm.clearMovTable()
      }
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('entry-manager', {
    ref: "entryManagerInternal",
    attrs: {
      "entriesList": _vm.internalEntries,
      "isInternal": true
    }
  })], 1)]), _c('div', {
    staticClass: "col-xs-6 col-flex"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "pending-title-manual-conciliation bold pull-left",
    staticStyle: {
      "color": "#00ace6 !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.gridExtratoBancario'))
    }
  }), (_vm.bankEntries.length > 0) ? _c('a', {
    staticClass: "pull-right clear-link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.limpar'))
    },
    on: {
      "click": function($event) {
        return _vm.clearBankTable()
      }
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('entry-manager', {
    ref: "entryManagerBank",
    attrs: {
      "entriesList": _vm.bankEntries,
      "isInternal": false
    }
  })], 1)])]), _c('div', {
    staticClass: "col-xs-12 row-flex"
  }, [_c('div', {
    staticClass: "col-xs-6 grey-right-border total-values col-flex"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.totalLancamentos'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.periodo'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.valorTotalInterno'))
    }
  })])]), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "1vh"
    }
  }, [_c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-value",
    domProps: {
      "innerHTML": _vm._s(_vm.totalAmoutOfEntriesMov)
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-date",
    domProps: {
      "innerHTML": _vm._s(_vm.rangeDateMov)
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-value",
    staticStyle: {
      "color": "#00ace6"
    },
    attrs: {
      "title": _vm.sumMov
    },
    domProps: {
      "innerHTML": _vm._s(_vm.sumMov)
    }
  })])])]), _c('div', {
    staticClass: "col-xs-6 total-values col-flex"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.valorTotalBancario'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.periodo'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.totalLancamentos'))
    }
  })])]), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "1vh"
    }
  }, [_c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-value",
    staticStyle: {
      "color": "#00ace6"
    },
    attrs: {
      "title": _vm.sumBank
    },
    domProps: {
      "innerHTML": _vm._s(_vm.sumBank)
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-date",
    domProps: {
      "innerHTML": _vm._s(_vm.rangeDateBank)
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-value",
    domProps: {
      "innerHTML": _vm._s(_vm.totalAmountOfEntriesBank)
    }
  })])])])]), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "border-top": "solid 2px #cccccc"
    }
  }, [_c('h4', {
    staticClass: "pending-divergence",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.divergencia'))
    }
  }), _c('h4', {
    class: _vm.getDivergenceAmoutClass()
  }, [_vm._v(_vm._s(_vm.totalTransformed))])]), _c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrayJustify && _vm.arrayJustify.length > 0),
      expression: "arrayJustify && arrayJustify.length > 0"
    }],
    staticClass: "col-xs-12 row-flex"
  }, [_c('div', {
    staticClass: "col-xs-12 col-flex"
  }, [_c('h4', {
    staticClass: "pending-title-manual-conciliation bold",
    staticStyle: {
      "color": "#00ace6 !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.arrayJustify.length > 1 ? _vm.$t('conciliacaoManual.titulos.justificativas') : _vm.$t('conciliacaoManual.titulos.justificativa'))
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('justifications', {
    ref: "justification"
  })], 1)])]), _c('br'), _c('div', {
    staticClass: "col-xs-12 centered"
  }, [_c('button-primary', {
    staticClass: "search-button",
    staticStyle: {
      "margin-right": "0px !important"
    },
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.reabrir'),
      "id": "btnReabrirLote",
      "clickFunction": _vm.reaopenAllotment,
      "disabled": !_vm.canReopen,
      "customClass": "secondary"
    }
  }), _c('button-primary', {
    staticClass: "search-button",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.aplicar'),
      "id": "btnAplicarLote",
      "customClass": "mid-button",
      "clickFunction": _vm.applyConciliation,
      "disabled": !_vm.canConciliate
    }
  }), _c('button-primary', {
    staticClass: "search-button",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.justificar'),
      "id": "btnJustificarLote",
      "clickFunction": _vm.justifyAllotment,
      "disabled": !_vm.divergentInstance,
      "customClass": "secondary"
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "col-xs-12 checkbox-centered"
  }, [_c('div', {
    staticClass: "checkbox check-success col-xs-1 pl-0 status-filter spaced-bottom-top"
  }, [(_vm.verifyAuthorizationResumeProcess) ? _c('input', {
    attrs: {
      "id": "automaticProcessing",
      "type": "checkbox",
      "disabled": !_vm.canResumeConciliation,
      "name": "automaticProcessing"
    },
    domProps: {
      "value": _vm.resumeAutomaticProcessing
    },
    on: {
      "change": _vm.changeReaplyConciliation
    }
  }) : _vm._e(), (_vm.verifyAuthorizationResumeProcess) ? _c('label', {
    staticClass: "control-label func-group-labels check-atribuidas",
    attrs: {
      "for": "automaticProcessing"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.reaplicarConciliacao'))
    }
  }) : _vm._e()])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7947ef80", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7947ef80"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/selectedEntries.pug
// module id = 1442
// module chunks = 0